import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
export const cartSlice = createSlice({
  name: "cart",
  initialState: {
    value: [],
  },
  reducers: {
    addToCart: (state, action) => {
      state.value = [...state.value, { key: uuidv4(), ...action.payload }];
    },
    removeItem: (state, action) => {
      const newList = state.value.filter((d) => d.key !== action.payload.key);
      state.value = newList;
    },
  },
});

export const { addToCart, removeItem } = cartSlice.actions;

// export const getCartItems = (cart) => cart;
export default cartSlice.reducer;
